import { tw } from '@/utils/tw';
import BaseFrontTheme from 'base/components/Front/theme';

const Front = tw.theme({
  extend: BaseFrontTheme,
  base: `relative gap-y-3 px-3 sm:gap-y-6 md:gap-y-8`,
});

export default Front;
